<template>
  <div id="auction-flip-grid">
    <v-toolbar
      flat
    >
      <v-toolbar-title class="text-h6 text-md-h5 pa-0">In Auction</v-toolbar-title>
    </v-toolbar>
    <v-row v-if="flipAuctionAssetList">
      <v-col
        v-for="(asset, a) in flipAuctionAssetList.entries"
        :key="a"
        cols="12"
        md="3"
        sm="6"
        class="align-self-stretch"
      >
        <CarCard :asset="asset"></CarCard>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import CarCard from '../components/CarCard.vue'
  import {mapGetters, mapActions } from 'vuex'

  export default {
    name: 'ActiveFlipGridAuction',

    components: {
      CarCard
    },

    computed: {
      ...mapGetters(['flipAuctionAssetList'])
    },

    data: () => ({
    }),

    methods: {
      ...mapActions(['getAuctionFlipAssets']),
    },

    created() {
      this.getAuctionFlipAssets()
    }
  }
</script>
